import { takeLatest, call, fork, put } from 'redux-saga/effects';

import * as Types from '../store/campaigns/types';
import * as Actions from '../store/campaigns/actions';

import { errorToast } from './commonGenerators/errorToast';
import { campaignsGET } from '@api/services/ElasticApi';
import { Campaign, CampaignStatus, CampaignTriggerType } from '@dev/ee-api/ee-api-models';
import { filter } from 'lodash-es';

const { ActionTypes } = Types;

const removeDraftsAndScheduledCampaings = (campaings: Campaign[]) =>
    filter(
        campaings,
        (campaign) =>
            campaign.Status === CampaignStatus.Completed ||
            (campaign.Status !== CampaignStatus.Draft && campaign.TriggerOptions.Type !== CampaignTriggerType.FutureScheduled)
    );

function* loadCampaigns({ payload: campaignsPayload }: Types.GetCampaingsAction): any {
    try {
        const { data: campaignsList } = yield call(campaignsGET, campaignsPayload);
        const filteredCampaings = removeDraftsAndScheduledCampaings(campaignsList);
        yield put(Actions.UpdateCampaignsStore(filteredCampaings));
    } catch (e) {
        yield put(Actions.CampaignsError());
        yield call(errorToast, e);
    }
}

function* watcherForLoadingCampaigns(): any {
    yield takeLatest(ActionTypes.GET_CAMPAIGNS, loadCampaigns);
}

const campaignsSaga = [fork(watcherForLoadingCampaigns)];

export default campaignsSaga;
